<app-lfsa-card *ngIf="!mostrarFormulario" [innTemplate]="enviarTemplate" [titulo]="'Parametros Conciliacion Bancaria'">
</app-lfsa-card>
<ng-template #enviarTemplate>
  <div class="container">
    <div class="row">
      <div class="col-md-9">
        <input #quickFilter (keyup)="onQuickFilterChanged()" [(ngModel)]="textoBuscar"
               class="form-control float-left " id="quickFilter " placeholder="Buscar.. "/>
      </div>
      <div class="col-md-3">
        <button (click)="abrirFormularioParaGuardarHTML()" class={{DAT_BTNCSS.success}}>
          Agregar Parametro
        </button>
      </div>
    </div>
    <div class="row">
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"
                       [columnDefs]="columnDefs" [frameworkComponents]="frameworkComponents"
                       [ngStyle]="diccionarioModulo.agGrid.style"
                       [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                       [pagination]="true" [rowData]="rowData"
                       [rowSelection]="rowSelection"
                       class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}">
      </ag-grid-angular>
    </div>
  </div>

</ng-template>

<!-- <div class="row col-md-12 animated fadeInRight" *ngIf="!mostrarFormulario">
    <h2 class="container float-left">
        Parametros Conciliacion Bancaria
    </h2>
    <hr />
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter " (keyup)="onQuickFilterChanged()" #quickFilter />
            </div>
            <div class="col-md-3">
                <button (click)="abrirFormularioParaGuardarHTML()" class={{DAT_BTNCSS.success}}>
                Agregar Parametro
                </button>
            </div>
        </div>
    </div>
    <ag-grid-angular
    class="{{diccionarioModulo.agGrid.class}}" #agGrid
    [ngStyle] = "diccionarioModulo.agGrid.style"
    id="{{diccionarioModulo.agGrid.id}}"
    paginationPageSize ="{{diccionarioModulo.agGrid.paginacion}}"
    [pagination]="true"

    [frameworkComponents]="frameworkComponents"
    [columnDefs]="columnDefs"
    [rowSelection]="rowSelection"
    [rowData]="rowData"
    (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div> -->

<!-- Formulario de Parametro Para Post -->
<app-lfsa-card *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm"
               [titulo]="'Parametros Conciliacion Bancaria'">
</app-lfsa-card>
<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div formGroupName="conciBancaParam">
      <div class="row col 12">
        <div class="form-group col-md-4">
          <app-lfsa-combo-box (change)="BancoEmpresa($event.target)" [claseLabel]="'letrasDanger'"
                              [comboBox]="cmbEmpresa" [control]="this.formulario.get('conciBancaParam.idEmpresa')"
                              [habilitar]="bloquearEditar"
                              [idOpcion]="'idEmpresa'" [id]="'idEmpresa'"
                              [label]="'Sociedad*'" [opcion]="'dscaEmpresa'" formControlName="idEmpresa">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-4">
          <app-lfsa-combo-box (change)="getRefBanco($event.target)" [claseLabel]="'letrasDanger'"
                              [comboBox]="cmbBanco" [control]="this.formulario.get('conciBancaParam.idBanco')"
                              [habilitar]="bloquearEditar"
                              [idOpcion]="'idBanco'"
                              [id]="'idBanco'" [label]="textoBanco"
                              [opcion]="'dscaBanco'"
                              formControlName="idBanco">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-md-4">
          <app-lfsa-input
            (input)="this.formulario.get('conciBancaParam').patchValue({'claveBanco': $any($event.target).value.toUpperCase()})"
            [claseLabel]="'letrasDanger'" [control]="this.formulario.get('conciBancaParam.claveBanco')"
            [id]="'claveBanco'" [isReadOnly]="bloquearEditar"
            [label]="'Clave Banco*'"
            [type]="'string'" formControlName="claveBanco">
          </app-lfsa-input>
        </div>
      </div>
      <div class="row col 12">
        <div class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-combo-box (change)="selectChangeArchivo()" [claseLabel]="'letrasDanger'" [comboBox]="cmbTipoArchivo"
                              [control]="this.formulario.get('conciBancaParam.formatoDucumento')" [idOpcion]="'id'"
                              [id]="'formatoDucumento'"
                              [label]="'Formato Archivo*'"
                              [opcion]="'valor'" formControlName="formatoDucumento"></app-lfsa-combo-box>
        </div>
        <div [hidden]="inabilitarSap" class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-input [claseLabel]="'letrasDanger'"
                          [control]="this.formulario.get('conciBancaParam.lineaInicialDatosDetalle')"
                          [id]="'lineaInicialDatosDetalle'"
                          [label]="'Linea Inicial Detalle*'" formControlName="lineaInicialDatosDetalle"
                          type="number">
          </app-lfsa-input>
        </div>
        <div [hidden]="dehabilitarCab" class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-input [claseLabel]="'letrasDanger'"
                          [control]="this.formulario.get('conciBancaParam.lineaInicialDatosCabecera')"
                          [id]="'lineaInicialDatosCabecera'"
                          [label]="'Linea Inicial Cabecera*'" [type]="'number'"
                          formControlName="lineaInicialDatosCabecera">
          </app-lfsa-input>
        </div>
      </div>
      <div [hidden]="inabilitarSap" class="row col-12">
        <div class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-combo-box (change)="selectChangeSaldo()" [claseLabel]="'letrasDanger'" [comboBox]="cmbValidacion"
                              [control]="this.formulario.get('conciBancaParam.saldoDisponibleInDetalle')"
                              [idOpcion]="'id'"
                              [id]="'saldoDisponibleInDetalle'"
                              [label]="'Saldo Disponible Cuerpo*'" [opcion]="'valor'"
                              formControlName="saldoDisponibleInDetalle"></app-lfsa-combo-box>
        </div>
        <div [hidden]="habilitarSaldo" class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-input [claseLabel]="'letrasDanger'"
                          [control]="this.formulario.get('conciBancaParam.columnaSaldoDispoible')"
                          [id]="'columnaSaldoDispoible'" [label]="'Saldo Disponible Columna*'" [type]="'number'"
                          formControlName="columnaSaldoDispoible">
          </app-lfsa-input>
        </div>
        <div [hidden]="habilitarSaldo" class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-input [claseLabel]="'letrasDanger'"
                          [control]="this.formulario.get('conciBancaParam.filaSaldoDisponible')"
                          [id]="'filaSaldoDisponible'"
                          [label]="'Saldo Disponible Fila*'" [type]="'number'"
                          formControlName="filaSaldoDisponible"></app-lfsa-input>
        </div>
      </div>
      <div class="row col-12">
        <div class="form-group col-md-4">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbDelimitador"
                              [control]="this.formulario.get('conciBancaParam.separador')"
                              [idOpcion]="'id'" [id]="'separador'"
                              [label]="'Delimitador*'" [opcion]="'valor'"
                              formControlName="separador"></app-lfsa-combo-box>
        </div>
        <div [hidden]="inabilitarSap" class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbformatCal"
                              [control]="this.formulario.get('conciBancaParam.formatoCalculo')"
                              [idOpcion]="'id'" [id]="'formatoCalculo'"
                              [label]="'F.Calculo*'" [opcion]="'valor'"
                              formControlName="formatoCalculo"></app-lfsa-combo-box>
        </div>
        <div [hidden]="inabilitarSap" class="form-group col-md-4 animated fadeInRight">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbOrdenArchivo"
                              [control]="this.formulario.get('conciBancaParam.ordenDocumento')"
                              [idOpcion]="'id'" [id]="'ordenDocumento'"
                              [label]="'Orden Archivo*'"
                              [opcion]="'valor'"
                              formControlName="ordenDocumento"></app-lfsa-combo-box>
        </div>
      </div>
    </div>
    <hr/>
    <div class="row col-md-12">
      <div [hidden]="habilitarCatalogo" class="form-group col-md-6 animated fadeInRight">
        <button (click)="addDetalle()" class="{{DAT_BTNCSS.primary}}"
                type="button">{{ DAT_BTNS.catalogo }}
        </button>
      </div>
    </div>
    <div class="row col 12">
      <div *ngIf="listConciBancaParamCampo" class="col-md-6">
        <div [hidden]="habilitarCatalogo" class="card animated fadeInRight">
          <div class="card-header">
            <strong>Catalogo</strong>
          </div>
          <div class="card-body">
            <div class="row col-md-12">
              <div class="col-md-6">Posicion Catalogo</div>
              <div class="col-md-6">Catalogo</div>
            </div>
            <div *ngFor="let item of listConciBancaParamCampo.controls; let i = index" class="col-12"
                 formArrayName="listConciBancaParamCampo">
              <div [formGroupName]="i">
                <div class="row mb-2 animated fadeInDown">
                  <div class="form-group col-md-4">
                    <input (change)="onCampoChange($event.target)" class="form-control"
                           formControlName="pisicionColumna"
                           type="number"/>
                    <app-lfsa-error-msg
                      [control]="listConciBancaParamCampo.controls[i].get('pisicionColumna')">
                    </app-lfsa-error-msg>
                  </div>
                  <div class="form-group col-md-6">
                    <select (change)="onCampoChange($event.target)" class="form-control"
                            formControlName="nombreCampo">
                      <option *ngFor="let option of cmbDatos" [ngValue]="option.value">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <button (click)="removeItem(i)" class="btn btn-danger"> &times;
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <br>
  <div class="row col-md-12">
    <div class="form-group col-md-12">
      <app-lfsa-botones-formulario (devolverAccion)="acciones($event)"
                                   [formularioValido]="formulario.invalid || validateDetalle"
                                   [textBoton]="textBoton"></app-lfsa-botones-formulario>
    </div>
  </div>
</ng-template>
<!-- <div class="row animated fadeInRight" *ngIf="mostrarFormulario">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <strong>Parametros Conciliacion Bancaria</strong>
            </div>
            <div class="card-body">
                <form [formGroup]="formulario" novalidate class="form-group">
                    <div formGroupName="conciBancaParam">
                        <div class="row col 12">
                            <div class="form-group col-md-4">
                                <app-lfsa-combo-box [habilitar]="bloquearEditar" [opcion]="'dscaEmpresa'"
                                    [idOpcion]="'idEmpresa'" [comboBox]="cmbEmpresa" formControlName="idEmpresa"
                                    [control]="this.formulario.get('conciBancaParam.idEmpresa')" [label]="'Sociedad'"
                                    [id]="'idEmpresa'" (change)="BancoEmpresa($event.target)"></app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-md-4">
                                <app-lfsa-combo-box [habilitar]="bloquearEditar" [opcion]="'dscaBanco'"
                                    [idOpcion]="'idBanco'" [comboBox]="cmbBanco" formControlName="idBanco"
                                    [control]="this.formulario.get('conciBancaParam.idBanco')" [label]="'Bancos'"
                                    [id]="'idBanco'"></app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-md-4">
                                <app-lfsa-input [isReadOnly]="bloquearEditar" [label]="'Clave Banco'" [type]="'string'"
                                    [id]="'claveBanco'"
                                    (input)="this.formulario.get('conciBancaParam').patchValue({'claveBanco': $event.target.value.toUpperCase()})"
                                    formControlName="claveBanco"
                                    [control]="this.formulario.get('conciBancaParam.claveBanco')"></app-lfsa-input>
                            </div>
                        </div>
                        <div class="row col 12">
                            <div class="form-group col-md-4 animated fadeInRight">
                                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbTipoArchivo"
                                    formControlName="formatoDucumento"
                                    [control]="this.formulario.get('conciBancaParam.formatoDucumento')"
                                    [label]="'Formato Archivo'" [id]="'formatoDucumento'"
                                    (change)="selectChangeArchivo()"></app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-md-4 animated fadeInRight" [hidden]="inabilitarSap">
                                <app-lfsa-input [label]="'Linea Inicial Detalle'" type="number"
                                    [id]="'lineaInicialDatosDetalle'" formControlName="lineaInicialDatosDetalle"
                                    [control]="this.formulario.get('conciBancaParam.lineaInicialDatosDetalle')">
                                </app-lfsa-input>
                            </div>
                            <div class="form-group col-md-4 animated fadeInRight" [hidden]="dehabilitarCab">
                                <app-lfsa-input [label]="'Linea Inicial Cabecera'" [type]="'number'"
                                    [id]="'lineaInicialDatosCabecera'" formControlName="lineaInicialDatosCabecera"
                                    [control]="this.formulario.get('conciBancaParam.lineaInicialDatosCabecera')">
                                </app-lfsa-input>
                            </div>
                        </div>
                        <div class="row col-12" [hidden]="inabilitarSap">
                            <div class="form-group col-md-4 animated fadeInRight">
                                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbValidacion"
                                    formControlName="saldoDisponibleInDetalle"
                                    [control]="this.formulario.get('conciBancaParam.saldoDisponibleInDetalle')"
                                    [label]="'Saldo Disponible Cuerpo'" [id]="'saldoDisponibleInDetalle'"
                                    (change)="selectChangeSaldo()"></app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-md-4 animated fadeInRight" [hidden]="habilitarSaldo">
                                <app-lfsa-input [label]="'Saldo Disponible Columna'" [type]="'number'"
                                    [id]="'columnaSaldoDispoible'" formControlName="columnaSaldoDispoible"
                                    [control]="this.formulario.get('conciBancaParam.columnaSaldoDispoible')">
                                </app-lfsa-input>
                            </div>
                            <div class="form-group col-md-4 animated fadeInRight" [hidden]="habilitarSaldo">
                                <app-lfsa-input [label]="'Saldo Disponible Fila'" [type]="'number'"
                                    [id]="'filaSaldoDisponible'" formControlName="filaSaldoDisponible"
                                    [control]="this.formulario.get('conciBancaParam.filaSaldoDisponible')"></app-lfsa-input>
                            </div>
                        </div>
                        <div class="row col-12">
                            <div class="form-group col-md-4">
                                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbDelimitador"
                                    formControlName="separador"
                                    [control]="this.formulario.get('conciBancaParam.separador')" [label]="'Delimitador'"
                                    [id]="'separador'"></app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-md-4 animated fadeInRight" [hidden]="inabilitarSap">
                                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbformatCal"
                                    formControlName="formatoCalculo"
                                    [control]="this.formulario.get('conciBancaParam.formatoCalculo')"
                                    [label]="'F.Calculo'" [id]="'formatoCalculo'"></app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-md-4 animated fadeInRight" [hidden]="inabilitarSap">
                                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbOrdenArchivo"
                                    formControlName="ordenDocumento"
                                    [control]="this.formulario.get('conciBancaParam.ordenDocumento')"
                                    [label]="'Orden Archivo'" [id]="'ordenDocumento'"></app-lfsa-combo-box>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="row col-md-12">
                        <div class="form-group col-md-6 animated fadeInRight" [hidden]="habilitarCatalogo">
                            <button type="button" class="{{DAT_BTNCSS.primary}}"
                                (click)="addDetalle()">{{DAT_BTNS.catalogo}}</button>
                        </div>
                    </div>
                    <div class="row col 12">
                        <div class="col-md-6" *ngIf="listConciBancaParamCampo">
                            <div class="card animated fadeInRight" [hidden]="habilitarCatalogo">
                                <div class="card-header">
                                    <strong>Catalogo</strong>
                                </div>
                                <div class="card-body">
                                    <div class="row col-md-12">
                                        <div class="col-md-6">Posicion Catalogo</div>
                                        <div class="col-md-6">Catalogo</div>
                                    </div>
                                    <div class="col-12" formArrayName="listConciBancaParamCampo"
                                        *ngFor="let item of listConciBancaParamCampo.controls; let i = index">
                                        <div [formGroupName]="i">
                                            <div class="row mb-2 animated fadeInDown">
                                                <div class="form-group col-md-4">
                                                    <input formControlName="pisicionColumna" type="number"
                                                        class="form-control" (change)="onCampoChange($event.target)" />
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <select formControlName="nombreCampo" class="form-control"
                                                        (change)="onCampoChange($event.target)">
                                                        <option [ngValue]="option.value"
                                                            *ngFor="let option of cmbDatos">
                                                            {{ option.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-md-2">
                                                    <button (click)="removeItem(i)" class="btn btn-danger"> &times;
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <br>
                <div class="row col-md-12">
                    <div class="form-group col-md-12">
                        <app-grid-botones [formularioValido]="formulario.invalid || validateDetalle"
                            (devolverAccion)="acciones($event)" [textBoton]="textBoton"></app-grid-botones>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
